import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';

const GenerateFactureBtn = (props) => {
    const t = useTranslate();

    const callback = (ticketRef) =>{
        props.setTicketRef(ticketRef)
        props.setRaisonPrint('generateInvoice')
        props.setRelance(Date.now())
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('billing')+' A4'}
                </Tooltip>
            }
        >
            <span onClick={() => callback(props.ticketRef)} className='pointer text-primary'><FontAwesomeIcon icon={faFileInvoice} /></span>
        </OverlayTrigger>  
    )
}

export default GenerateFactureBtn;